import RaiseButton from "./raiseButton/raiseButton";
import { ActionButton } from "./actionButton";
import { ChangeableTextButton } from "./changeableTextButton";
import { TimeBank } from "./timeBank";
import { WebSocketManager } from "../../../helpers/webSocketManager";
import { WaitingListBtn } from "./waitingListBtn";
import { StraddleBtns } from "./straddleBtns";
import { AddOnBtn } from "./addOnBtn";
import localScaleManager from "../../../helpers/LocalScaleManager";

export class ButtonManager {
  /**
   * @param scene {GameScene}
   * @param table {Table}
   */
  constructor(scene, table) {
    this.scene = scene;
    this.tableNumber = table.tableNumber;
    this.table = table;
    this.selfPlayer = null;

    this.rightBtnObj = this.scene.add
      .image(0, 0, this.scene.atlasTexture, "all-in-btn")
      .setInteractive({ cursor: "pointer" })
      .setVisible(false);
    this.centerBtnObj = this.scene.add
      .image(0, 0, this.scene.atlasTexture, "check-btn")
      .setInteractive({ cursor: "pointer" })
      .setVisible(false);
    this.leftBtnObj = this.scene.add
      .image(0, 0, this.scene.atlasTexture, "fold-btn")
      .setInteractive({ cursor: "pointer" })
      .setVisible(false);
    this.table.poolArray.push(this.rightBtnObj);
    this.table.poolArray.push(this.centerBtnObj);
    this.table.poolArray.push(this.leftBtnObj);

    this.foldBtn = new ActionButton(
      this.scene,
      table,
      "fold-btn",
      "poker.client-push.fold",
      false,
      this.leftBtnObj
    );
    this.checkBtn = new ActionButton(
      this.scene,
      table,
      "check-btn",
      "poker.client-push.check",
      false,
      this.centerBtnObj
    );
    this.raiseBtn = new RaiseButton(this.scene, table, this.rightBtnObj);
    this.callBtn = new ChangeableTextButton(
      this.scene,
      table,
      "call-btn",
      "poker.client-push.call",
      false,
      this.centerBtnObj
    );
    // this.betBtn = new RaiseButton(this.scene, table, true);
    this.allInBtn = new ActionButton(
      this.scene,
      table,
      "all-in-btn",
      "poker.client-push.allin",
      false,
      this.rightBtnObj
    );
    this.straddleBtns = new StraddleBtns(
      this.scene,
      table,
      this.rightBtnObj,
      this.leftBtnObj
    );

    this.timeBankBtn = new TimeBank(this.scene, table);

    this.actionButtonFrames = [
      "fold-btn",
      "check-btn",
      "call-btn",
      "all-in-btn",
      "raise-btn",
      "bet-btn",
    ];
    // this.table.poolArray.push(this.actionButtonsGroup);

    this.fcBtn = new ActionButton(
      this.scene,
      table,
      "fc-btn",
      "poker.client-push.auto-check-fold",
      true,
      this.leftBtnObj
    );
    this.callAnyBtn = new ActionButton(
      this.scene,
      table,
      "call-any-btn",
      "poker.client-push.auto-check-call",
      true,
      this.rightBtnObj
    );
    this.reserveCallBtn = new ChangeableTextButton(
      this.scene,
      table,
      "reserve-call-btn",
      "poker.client-push.auto-call",
      true,
      this.centerBtnObj
    );
    this.reserveCheckBtn = new ActionButton(
      this.scene,
      table,
      "reserve-check-btn",
      "poker.client-push.auto-check",
      true,
      this.centerBtnObj
    );

    this.reserveButtonFrames = [
      "fc-btn",
      "fc-btn-on",
      "call-any-btn",
      "call-any-btn-on",
      "reserve-call-btn",
      "reserve-call-btn-on",
      "reserve-check-btn",
      "reserve-check-btn-on",
    ];
    // this.table.poolArray.push(this.reserveButtonsGroup);
    this.reserveButtonsGroup = [
      this.fcBtn,
      this.callAnyBtn,
      this.reserveCallBtn,
      this.reserveCheckBtn,
    ];

    this.startNowBtn = new ActionButton(
      this.scene,
      table,
      "start-now-btn",
      "poker.client-push.join-now",
      false,
      this.leftBtnObj
    );
    this.imBackBtn = new ActionButton(
      this.scene,
      table,
      "im-back-btn",
      "poker.client-push.ready",
      false,
      this.leftBtnObj
    );
    this.joinWaitingListBtn = new WaitingListBtn(
      this.scene,
      table,
      "join-waiting-list-btn",
      "poker.client-push.join-waitlist",
      this.leftBtnObj
    );
    this.cancelWaitingListBtn = new WaitingListBtn(
      this.scene,
      table,
      "unjoin-waiting-list",
      "poker.client-push.leave-waitlist",
      this.leftBtnObj
    );
    this.addOnBtn = new AddOnBtn(
      this.scene,
      table,
      "add-on-btn",
      "",
      this.rightBtnObj
    );

    this.otherButtonFrames = [
      "start-now-btn",
      "im-back-btn",
      "join-waiting-list-btn",
      "unjoin-waiting-list",
      "add-on-btn",
    ];
    // this.table.poolArray.push(this.otherButtonsGroup);
  }
  hideAllButtons() {
    // this.actionButtonsGroup.forEach((btn) => btn.hide());
    // this.reserveButtonsGroup.forEach((btn) => btn.hide());
    // this.otherButtonsGroup.forEach((btn) => btn.hide());
    this.hideStraddleButtons();
    if (this.rightBtnObj.visible) this.rightBtnObj.setVisible(false);
    if (this.leftBtnObj.visible) this.leftBtnObj.setVisible(false);
    if (this.centerBtnObj.visible) this.centerBtnObj.setVisible(false);
    this.raiseBtn.hide();
    this.callBtn.hide();
    this.reserveCallBtn.hide();
  }
  hideReserveButtons() {
    if (this.reserveButtonFrames.includes(this.rightBtnObj.frame.name)) {
      if (this.rightBtnObj.visible) this.rightBtnObj.setVisible(false);
    }
    if (this.reserveButtonFrames.includes(this.leftBtnObj.frame.name)) {
      if (this.leftBtnObj.visible) this.leftBtnObj.setVisible(false);
    }
    if (this.reserveButtonFrames.includes(this.centerBtnObj.frame.name)) {
      if (this.centerBtnObj.visible) this.centerBtnObj.setVisible(false);
    }
    this.reserveCallBtn.hide();
  }
  hideActionButtons() {
    if (this.actionButtonFrames.includes(this.rightBtnObj.frame.name)) {
      if (this.rightBtnObj.visible) this.rightBtnObj.setVisible(false);
    }
    if (this.actionButtonFrames.includes(this.leftBtnObj.frame.name)) {
      if (this.leftBtnObj.visible) this.leftBtnObj.setVisible(false);
    }
    if (this.actionButtonFrames.includes(this.centerBtnObj.frame.name)) {
      if (this.centerBtnObj.visible) this.centerBtnObj.setVisible(false);
    }
    this.raiseBtn.hide();
    this.callBtn.hide();
  }
  hideOtherButtons() {
    if (this.otherButtonFrames.includes(this.rightBtnObj.frame.name)) {
      if (this.rightBtnObj.visible) this.rightBtnObj.setVisible(false);
    }
    if (this.otherButtonFrames.includes(this.leftBtnObj.frame.name)) {
      if (this.leftBtnObj.visible) this.leftBtnObj.setVisible(false);
    }
    if (this.otherButtonFrames.includes(this.centerBtnObj.frame.name)) {
      if (this.centerBtnObj.visible) this.centerBtnObj.setVisible(false);
    }
  }
  hideStraddleButtons() {
    if (
      ["straddle", "decline-straddle"].includes(this.rightBtnObj.frame.name)
    ) {
      if (this.rightBtnObj.visible) this.rightBtnObj.setVisible(false);
    }
    if (["straddle", "decline-straddle"].includes(this.leftBtnObj.frame.name)) {
      if (this.leftBtnObj.visible) this.leftBtnObj.setVisible(false);
    }
    this.straddleBtns.hide();
  }
  hideAddOnBtn() {
    if (this.rightBtnObj.frame.name === "add-on-btn") {
      if (this.rightBtnObj.visible) this.rightBtnObj.setVisible(false);
    }
  }
  handleGameState(state) {
    if (state.redealConfirmation) {
      this.hideAllButtons();
    } else {
      this.selfPlayer = state.playerInfo;
      if (
        this.selfPlayer &&
        state.redealPlayers.find((p) => p == this.selfPlayer.id)
      ) {
        this.hideAllButtons();
        return;
      }
      if (state.state !== "End") {
        if (state.state === "Straddle") {
          if (this.selfPlayer && this.selfPlayer.id === state.straddlePlayer) {
            this.hideAllButtons();
            this.straddleBtns.show(this.selfPlayer.timeRemaining);
            return;
          } else if (this.table.isTableVisiting()) {
            this.scene.alertify.tableAlert("Waiting for straddle...");
          }
        } else if (this.straddleBtns.isShown) this.hideStraddleButtons();
        this.raiseBtn.updateFastBetButtons(state);
        // this.betBtn.updateFastBetButtons(state);
        if (this.selfPlayer) {
          if (this.table.messageBox.text) this.table.messageBox.updateText(""); // Clear the text: "you have joined to the waiting list"
          if (this.selfPlayer.state !== "Leaving") {
            if (
              ((this.selfPlayer.state === "SitOut" &&
                this.selfPlayer.balance !== 0) ||
                this.selfPlayer.afk) &&
              state.state !== "Rebuy"
            ) {
              this.hideAllButtons();
              this.imBackBtn.show();
            } else if (
              this.selfPlayer.state === "WaitToJoin" &&
              this.selfPlayer.joinMode === "OnBB"
            ) {
              if (!this.table.isTournamentTable()) {
                this.hideAllButtons();
                this.startNowBtn.show();
              }
            } else if (
              this.selfPlayer.state === "WaitToJoin" &&
              this.selfPlayer.joinMode !== "OnBB" &&
              this.selfPlayer.joinMode !== "Joined"
            ) {
              this.hideAllButtons();
            }
            if (
              this.selfPlayer.state !== "WaitToJoin" &&
              this.selfPlayer.state !== "SitOut" &&
              !this.selfPlayer.afk
            ) {
              this.startNowBtn.hide();
              this.imBackBtn.hide();
            }

            // check data
            // this.hideAllButtons();
            if (
              this.selfPlayer.joinMode === "Joined" &&
              this.selfPlayer.lastAction !== "Fold" &&
              this.selfPlayer.state !== "AllIn" &&
              !this.selfPlayer.afk
            ) {
              if (this.selfPlayer.id === state.playerInTurn) {
                if (this.selfPlayer.autoAction !== "None") return;
                if (
                  !state.newState &&
                  // (this.raiseBtn.menuIsActive || this.betBtn.menuIsActive)
                  this.raiseBtn.menuIsActive
                )
                  return;
                // this.timeBankBtn.show();
                this.hideReserveButtons();
                if (state.maxBet > this.selfPlayer.bet) {
                  if (
                    state.maxBet >
                    this.selfPlayer.bet + this.selfPlayer.balance
                  ) {
                    this.allInBtn.show();
                  } else if (
                    state.maxBet >
                    this.selfPlayer.bet + state.minimumRaise
                  ) {
                    this.callBtn.updateText(state.maxBet - this.selfPlayer.bet);
                    this.callBtn.show();
                    this.allInBtn.show();
                  } else {
                    if (
                      state.maxBet - this.selfPlayer.bet !==
                        this.selfPlayer.balance &&
                      this.selfPlayer.isRaiseEnable
                    )
                      this.raiseBtn.show("raise");
                    this.callBtn.updateText(state.maxBet - this.selfPlayer.bet);
                    this.callBtn.show();
                  }
                  this.foldBtn.show();
                } else {
                  // this.betBtn.show();
                  this.raiseBtn.show("bet");
                  this.checkBtn.show();
                  this.foldBtn.show(false, true);
                }

                //moved to time remaining coroutine...

                // if (state.minimumRaise > this.selfPlayer.balance)
                // {
                //     this.allInBtn.show();
                //     this.raiseBtn.hide();
                // }
                // this.fcBtn.hide();
                // this.reserveCheckBtn.hide();
              } else if (
                this.selfPlayer.state !== "WaitToStart" &&
                state.state !== "Straddle"
              ) {
                // this.timeBankBtn.hide();
                this.hideActionButtons();
                if (state.maxBet > this.selfPlayer.bet) {
                  if (
                    state.maxBet >
                    this.selfPlayer.bet + this.selfPlayer.balance
                  ) {
                    this.reserveCallBtn.hide();
                    this.centerBtnObj.setVisible(false);
                    // this.allInBtn.show()
                  } else if (
                    state.maxBet >
                    this.selfPlayer.bet + state.minimumRaise
                  ) {
                    this.reserveCheckBtn.hide();
                    this.reserveCallBtn.updateText(
                      state.maxBet - this.selfPlayer.bet
                    );
                    this.reserveCallBtn.show(
                      this.selfPlayer.autoAction === "Call"
                    );
                    // this.allInBtn.show();
                  } else {
                    // this.raiseBtn.show();
                    this.reserveCheckBtn.hide();
                    this.reserveCallBtn.updateText(
                      state.maxBet - this.selfPlayer.bet
                    );
                    this.reserveCallBtn.show(
                      this.selfPlayer.autoAction === "Call"
                    );
                  }
                } else {
                  // this.betBtn.show();

                  this.reserveCallBtn.hide();
                  this.reserveCheckBtn.show(
                    this.selfPlayer.autoAction === "Check"
                  );
                }
                this.fcBtn.show(this.selfPlayer.autoAction === "CheckFold");
                this.callAnyBtn.show(
                  this.selfPlayer.autoAction === "CheckCall"
                );
              }
            } else if (
              (this.selfPlayer.lastAction === "Fold" ||
                this.selfPlayer.state === "AllIn") &&
              !this.selfPlayer.afk
            ) {
              this.hideAllButtons();
            }
          } else {
            this.hideAllButtons();
          }
        } else {
          if (this.table.seats.length === this.table.playerSeats.length) {
            // If the table is full.
            this.updateWaitingList();
          } else {
            // If the table isn't full.
            this.hideAllButtons();
            if (this.table.messageBox.text) {
              this.table.messageBox.updateText("");
            }
          }
        }
        if (!state.playerInTurn) {
          this.hideReserveButtons();
          this.hideActionButtons();
        }
      } else if (state.state === "End") {
        this.hideAllButtons();
        if (this.selfPlayer && state.state !== "Rebuy") {
          if (
            (this.selfPlayer.state === "SitOut" &&
              this.selfPlayer.balance !== 0) ||
            this.selfPlayer.afk
          ) {
            this.imBackBtn.show();
          }
        }
      }
    }
  }
  /**
   * @return {Promise<{joined: boolean, count: number, position: number}>}
   */
  async getWaitingList() {
    try {
      const res = await WebSocketManager.emitEvent(
        { tableId: this.table.tableInfo.id },
        "poker.client-pull.get-waitlist"
      );
      const list = res.waitList;
      const joined = !!list.find((user) => user.userId === this.scene.user.id);
      return { joined: joined, count: res.count, position: res.position };
    } catch (e) {
      console.error(e);
      return false;
    }
  }
  updateWaitingList() {
    if (this.selfPlayer || this.table.isTournamentTable()) return;
    this.getWaitingList().then((res) => {
      if (res.joined) {
        // If the self-player has already joined the waiting list.
        this.hideAllButtons();
        this.cancelWaitingListBtn.show();
        this.table.messageBox.updateText(
          `You have joined the waiting list: ${res.position} of ${res.count}`
        );
      } else {
        // If the self-player hasn't joined the waiting list yet.
        this.joinWaitingListBtn.show();
        this.table.messageBox.updateText("");
      }
    });
  }
  /**
   * @param  initX {number} x of table
   * @param  initY {number} y of table
   * @param  width {number} width of table
   * @param height {number} height of table
   */
  positionControls(initX, initY, width, height) {
    this.tableNumber = this.table.tableNumber;

    const btnInitX = this.scene.gameWidth * (this.tableNumber - 1);
    let btnSize = width / 3.1;
    localScaleManager.scaleSprite(
      this.rightBtnObj,
      btnSize,
      btnSize,
      0,
      1,
      true
    );
    localScaleManager.scaleSprite(
      this.centerBtnObj,
      btnSize,
      btnSize,
      0,
      1,
      true
    );
    localScaleManager.scaleSprite(
      this.leftBtnObj,
      btnSize,
      btnSize,
      0,
      1,
      true
    );

    this.rightBtnObj.setPosition(
      btnInitX + this.scene.gameWidth / 2 + this.rightBtnObj.displayWidth + 3,
      this.scene.gameHeight - this.rightBtnObj.displayHeight
    );
    this.centerBtnObj.setPosition(
      btnInitX + this.scene.gameWidth / 2,
      this.scene.gameHeight - this.centerBtnObj.displayHeight
    );
    this.leftBtnObj.setPosition(
      btnInitX + this.scene.gameWidth / 2 - this.leftBtnObj.displayWidth - 3,
      this.scene.gameHeight - this.leftBtnObj.displayHeight
    );

    this.rightBtnObj.setData("initScale", this.rightBtnObj.scale);
    this.centerBtnObj.setData("initScale", this.centerBtnObj.scale);
    this.leftBtnObj.setData("initScale", this.leftBtnObj.scale);
    // this.foldBtn.positionControls(width, height, "left");
    // this.checkBtn.positionControls(width, height, "center");
    this.raiseBtn.positionControls(width, height);
    this.callBtn.positionControls(width, height);
    // this.allInBtn.positionControls(width, height, "right");

    // this.imBackBtn.positionControls(width, height, "left");
    // this.joinWaitingListBtn.positionControls(width, height, "left");
    // this.cancelWaitingListBtn.positionControls(width, height, "left");
    // this.startNowBtn.positionControls(width, height, "left");

    // this.fcBtn.positionControls(width, height, "left");
    // this.callAnyBtn.positionControls(width, height, "right");
    this.reserveCallBtn.positionControls(width, height);
    // this.reserveCheckBtn.positionControls(width, height, "center");
    // if (this.table.isTournamentTable())
    //   this.addOnBtn.positionControls(width, height, "right");

    this.straddleBtns.positionControls(width, height);
    this.timeBankBtn.positionControls(initX, initY, width, height);
  }
  reposition(initX, initY, width, height) {
    this.tableNumber = this.table.tableNumber;

    const btnInitX = this.scene.gameWidth * (this.tableNumber - 1);
    this.rightBtnObj.setPosition(
      btnInitX + this.scene.gameWidth / 2 + this.rightBtnObj.displayWidth + 3,
      this.scene.gameHeight - this.rightBtnObj.displayHeight
    );
    this.centerBtnObj.setPosition(
      btnInitX + this.scene.gameWidth / 2,
      this.scene.gameHeight - this.centerBtnObj.displayHeight
    );
    this.leftBtnObj.setPosition(
      btnInitX + this.scene.gameWidth / 2 - this.leftBtnObj.displayWidth - 3,
      this.scene.gameHeight - this.leftBtnObj.displayHeight
    );

    // this.foldBtn.reposition(width, height, "left");
    // this.checkBtn.reposition(width, height, "center");
    this.raiseBtn.reposition(width, height);
    this.callBtn.reposition(width, height);
    // this.allInBtn.reposition(width, height, "right");

    // this.imBackBtn.reposition(width, height, "left");
    // this.joinWaitingListBtn.reposition(width, height, "left");
    // this.cancelWaitingListBtn.reposition(width, height, "left");
    // this.startNowBtn.reposition(width, height, "left");

    // this.fcBtn.reposition(width, height, "left");
    // this.callAnyBtn.reposition(width, height, "right");
    this.reserveCallBtn.reposition(width, height);
    // this.reserveCheckBtn.reposition(width, height, "center");
    // if (this.table.isTournamentTable())
    //   this.addOnBtn.reposition(width, height, "right");

    this.straddleBtns.reposition(width, height);
    this.timeBankBtn.reposition(initX, initY, width, height);
    this.hideAllButtons();
  }
  remove() {
    this.actionButtonsGroup.children.iterate((btn) => {
      if (btn) btn.remove();
    });
    this.actionButtonsGroup.destroy(true);
    this.reserveButtonsGroup.children.iterate((btn) => {
      if (btn) btn.remove();
    });
    this.reserveButtonsGroup.destroy(true);
    this.otherButtonsGroup.children.iterate((btn) => {
      if (btn) btn.remove();
    });
    this.otherButtonsGroup.destroy(true);
    this.timeBankBtn.remove();
  }
}
